import React from 'react'

const Manual_invukds_configuraciones_estaciones = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          InvuKDS Configuraciones - Estaciones
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Siguiendo estos pasos, los usuarios pueden optimizar su flujo de trabajo y garantizar
          operaciones fluidas en su restaurante, permitiendo gestionar y transferir comandos
          eficazmente entre diferentes pantallas de KDS.
        </p>
        <iframe
          src="https://scribehow.com/embed/InvuKDS_Configuraciones__Estaciones__pvo2p3yfRpGG5XkKwHLiHQ?as=scrollable"
          className="scribe-iframe-general-7"
          width="100%"
          height="3600"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_invukds_configuraciones_estaciones